import * as R from 'ramda';

const selectedView = (state: any) => R.pathOr('', ['myfleet', 'selectedView'], state);
const searchType = (state: any) => R.pathOr('', ['myfleet', 'searchType'], state);
const statsName = (state: any) => R.pathOr('', ['myfleet', 'statsName'], state);
const filters = (state: any) => state.myfleet.filters;
const tilePagination = (state: any) => state.myfleet.tilePagination;
const gridPagination = (state: any) => state.myfleet.gridPagination;
const listPagination = (state: any) => state.myfleet.listPagination;
const loadmapview = (state: any) => R.pathOr('', ['myfleet', 'loadmapview'], state);
const mapMetaData = (state: any) => R.pathOr('', ['myfleet', 'mapMetaData'], state);
const loadperfchartview = (state: any) => R.pathOr('', ['myfleet', 'loadperfchartview'], state);
const applyClick = (state: any) => R.pathOr('', ['myfleet', 'applyClick'], state);

const selectors = {
    selectedView,
    searchType,
    statsName,
    filters,
    tilePagination,
    gridPagination,
    listPagination,
    loadmapview,
    mapMetaData,
    loadperfchartview,
    applyClick
};

export default selectors;
